import mutations from './mutations.js';
import getters from './getters.js';
import actions from './actions.js';

const usb = {
  namespaced: true,
  state() {
    return {
      usbProducts: [],
      usbLicenseTexts: [],
      usbData: {},
      isUSBAPIError:false,
    };
  },
  mutations,
  getters,
  actions
};

export default usb;